import React from 'react';
import { EventProps } from './Event.types';

export const ExampleEvent: EventProps = {
  id: 'event-1',
  name: 'Family Fun Day at Wicksteed Park',
  description: 'Join us for an exciting family fun day with activities for all ages. There will be face painting, balloon animals, live music, and special discounts on park rides. A perfect day out for families with children of all ages.',
  descriptionElement: (
    <div>
      <p>Join us for an exciting family fun day with activities for all ages. There will be face painting, balloon animals, live music, and special discounts on park rides.</p>
      <p>A perfect day out for families with children of all ages. Food and refreshments will be available throughout the day.</p>
    </div>
  ),
  startDateTime: '2025-07-15T10:00:00',
  endDateTime: '2025-07-15T16:00:00',
  eventType: 'Family Event',
  audience: ['Families', 'Children', 'Young People'],
  organization: {
    id: 'org-1',
    name: 'Wicksteed Park',
    description: 'A family theme park and nature reserve in Kettering',
    logo: 'https://placehold.co/200x100?text=Wicksteed+Park',
    url: 'https://www.wicksteedpark.co.uk',
  },
  location: {
    id: 1,
    name: 'Wicksteed Park',
    description: 'Main entrance and activities area',
    isVisitable: true,
    latitude: '52.3991',
    longitude: '-0.7358',
    address: {
      id: 1,
      address1: 'Barton Road',
      city: 'Kettering',
      county: 'Northamptonshire',
      postcode: 'NN15 6NJ',
      country: 'United Kingdom',
    },
    accessibility: [
      {
        id: 1,
        accessibility: 'Wheelchair accessible paths',
      },
      {
        id: 2,
        accessibility: 'Accessible toilets',
      },
      {
        id: 3,
        accessibility: 'Disabled parking available',
      },
    ],
  },
  email: 'events@wicksteedpark.co.uk',
  fees: 'Free entry to event activities. Park entry charges apply.',
  url: 'https://www.wicksteedpark.co.uk/events/family-fun-day',
  websiteUrlTitle: 'Book tickets online',
  contacts: [
    {
      id: 1,
      name: 'Event Information',
      title: 'General Enquiries',
      phones: [
        {
          id: 1,
          number: '01536 512475',
        },
      ],
    },
  ],
  uploads: [
    {
      title: 'Event Programme',
      url: '/files/family-fun-day-programme.pdf',
      size: '2.5MB',
      type: 'PDF',
      archived: false,
    },
    {
      title: 'Activity Map',
      url: '/files/activity-map.pdf',
      size: '1.2MB',
      type: 'PDF',
      archived: false,
    },
  ],
  socialProfiles: [
    {
      id: 1,
      name: 'Wicksteed Park Facebook',
      social_network: 'facebook',
      link: 'https://facebook.com/wicksteedpark',
    },
    {
      id: 2,
      name: 'Wicksteed Park Twitter',
      social_network: 'twitter',
      link: 'https://twitter.com/wicksteedpark',
    },
  ],
  updatedAt: '2025-01-15',
  shortListPath: '/events/shortlist',
  isRecurring: false,
  registrationDeadline: '2025-07-10T23:59:59',
  capacity: 500,
  currentAttendees: 342,
};

export const ExampleVirtualEvent: EventProps = {
  id: 'event-2',
  name: 'Online Parenting Workshop: Managing Screen Time',
  description: 'A comprehensive online workshop for parents and carers about managing children\'s screen time effectively. Learn practical strategies, understand the latest research, and connect with other parents.',
  descriptionElement: (
    <div>
      <p>A comprehensive online workshop for parents and carers about managing children's screen time effectively.</p>
      <p>During this 2-hour session, you'll learn:</p>
      <ul>
        <li>Evidence-based strategies for healthy screen time limits</li>
        <li>How to create engaging offline activities</li>
        <li>Understanding age-appropriate content</li>
        <li>Building family media agreements</li>
      </ul>
      <p>There will be time for Q&A and connecting with other parents.</p>
    </div>
  ),
  startDateTime: '2025-03-20T19:00:00',
  endDateTime: '2025-03-20T21:00:00',
  eventType: 'Workshop',
  audience: ['Parents', 'Carers'],
  organization: {
    id: 'org-2',
    name: 'Northamptonshire Family Support',
    description: 'Supporting families across Northamptonshire',
    logo: 'https://placehold.co/200x100?text=Family+Support',
    url: 'https://www.northantsfamilysupport.org.uk',
  },
  location: {
    id: 2,
    name: 'Online Event',
    description: 'Join from the comfort of your own home',
    isVirtual: true,
    virtualMeetingInfo: 'Zoom link will be sent 24 hours before the event. Please ensure you have a stable internet connection and a quiet space.',
  },
  email: 'workshops@northantsfamilysupport.org.uk',
  fees: 'Free',
  url: 'https://www.northantsfamilysupport.org.uk/workshops/screen-time',
  websiteUrlTitle: 'Register for this workshop',
  contacts: [
    {
      id: 1,
      name: 'Workshop Team',
      title: 'Registration Support',
      phones: [
        {
          id: 1,
          number: '01604 123456',
        },
      ],
    },
  ],
  uploads: [
    {
      title: 'Workshop Preparation Guide',
      url: '/files/screen-time-prep-guide.pdf',
      size: '800KB',
      type: 'PDF',
      archived: false,
    },
  ],
  updatedAt: '2025-01-10',
  shortListPath: '/events/shortlist',
  isRecurring: true,
  recurrencePattern: 'Monthly on the third Thursday',
  registrationDeadline: '2025-03-18T23:59:59',
  capacity: 50,
  currentAttendees: 23,
};

export const ExampleEvents: EventProps[] = [
  ExampleEvent,
  ExampleVirtualEvent,
  {
    id: 'event-3',
    name: 'Youth Football Tournament',
    description: 'Annual youth football tournament for ages 8-16. Teams from across Northamptonshire compete in age-appropriate divisions.',
    startDateTime: '2025-06-14T09:00:00',
    endDateTime: '2025-06-14T17:00:00',
    eventType: 'Sports',
    audience: ['Young People', 'Children'],
    organization: {
      id: 'org-3',
      name: 'Northampton Town FC Community Trust',
      description: 'Community outreach and youth development',
      logo: 'https://placehold.co/200x100?text=NTFC+Trust',
      url: 'https://www.ntfc.co.uk/community',
    },
    location: {
      id: 3,
      name: 'Northampton Town FC Training Ground',
      latitude: '52.2405',
      longitude: '-0.9027',
      address: {
        id: 3,
        address1: 'Moulton College',
        address2: 'West Street',
        city: 'Moulton',
        county: 'Northamptonshire',
        postcode: 'NN3 7RR',
        country: 'United Kingdom',
      },
    },
    fees: '£10 per team',
    url: 'https://www.ntfc.co.uk/community/youth-tournament',
    updatedAt: '2025-01-08',
    capacity: 32,
    currentAttendees: 28,
  },
];